/** @format */

import React from 'react'

const Portfolio = () => {
	return <div>Portfolio Page</div>
}

export default Portfolio
